export default "{\n  currentOrder {\n    promotionAdjustment {\n      code\n      amount\n      currency\n    }\n  }\n}\n"